import React from 'react'
import { FieldArray, reduxForm, InjectedFormProps } from 'redux-form'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress'

import { useTranslation } from 'react-i18next'
import { asyncValidateEmail } from '../../../validation/asyncValidate'
import EnvironmentUsersFieldComponent from '../../../components/FormInput/EnvironmentUsersFieldComponent'
import { InitialEnvironmentUser } from '../../../types/environments'
import ErrorMessage from '../../../components/Errors/ErrorMessage'

interface OwnProps {
  addUsers: (formData: InitialEnvironmentUser[]) => void
  closeDialog: () => void
}

const AddEnvironmentUsersForm: React.FC<OwnProps &
  InjectedFormProps<InitialEnvironmentUser[], OwnProps>> = ({
  handleSubmit,
  submitting,
  addUsers,
  closeDialog,
  error
}) => {
  const [t] = useTranslation()
  return (
    <form onSubmit={handleSubmit(addUsers)}>
      <FieldArray name='users' component={EnvironmentUsersFieldComponent} props={{ t }} />
      <Grid container>
        <Grid item xs={12} sm={12}>
          {submitting && <LinearProgress />}
          <ErrorMessage message={error} />
        </Grid>
      </Grid>
      <DialogActions>
        <Button onClick={closeDialog} color='primary'>
          {t('general.cancel')}
        </Button>
        <Button disabled={submitting} color='primary' type='submit'>
          {t('general.save')}
        </Button>
      </DialogActions>
    </form>
  )
}
export default reduxForm<InitialEnvironmentUser[], OwnProps>({
  form: 'AddEnvironmentUserForm',
  asyncValidate: asyncValidateEmail,
  asyncBlurFields: ['users[].email']
})(AddEnvironmentUsersForm)
